import { createTheme } from '@mui/material/styles';
import { responsiveFontSizes } from "@mui/material/styles";

export const colors = {
  tealDark: {
    100: '#010706',
    200: '#03100D',
    300: '#051914',
    400: '#08221A',
    500: '#0D2617', // базовый цвет
    600: '#294438',
    700: '#496256',
    800: '#6A8176',
    900: '#8BA098',
  },
  orange: {
    100: '#4A1F0D',
    200: '#713016',
    300: '#9A401C',
    400: '#C45022',
    500: '#EC5E27', // базовый цвет
    600: '#F0784A',
    700: '#F4946D',
    800: '#F8B59A',
    900: '#FCD8CB',
  },
  white: {
    100: '#FFFFFF',
    200: '#F5F5F5',
    300: '#E0E0E0',
    400: '#BDBDBD',
    500: '#ededed', // базовый цвет
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
  },

}


export const getTheme = (mode) => {
  return responsiveFontSizes(
    createTheme({
      palette: {
        mode,
        error: {
          main: "#ff4f71",
        },
        primary: {
          main: colors.orange[500],
          contrastText: colors.tealDark[500],
        },

        secondary: {
          main: colors.tealDark[500],
        },

        white: {
          main: colors.white[500],
        },
        
        background: {
          default: mode === 'light' ? colors.white[500] : '#0e151f',
          paper: mode === 'light' ? colors.white[100] : '#181f2c',
        },
      },

      typography: {
        fontSize: 13,
        subtitle1: {
          fontWeight: 'bold',
        },
      },

      text: {
        primary: {
          main: mode === 'light' ? colors.tealDark[500] : colors.white[500],
        },
        secondary: {
          main: mode === 'light' ? colors.tealDark[400] : colors.white[400],
        },
        white: {
          main: colors.white[500],
        },
      },

      components: {
          
          MuiButton: {
            styleOverrides: {
              containedPrimary: {
                backgroundColor: colors.orange[500],
                '&:hover': {
                  backgroundColor: colors.orange[600],
                },
              },
            },
          },
      
          
      
          
      
        }



    })
  )
}
